<template>
    <v-card  width="344" ma-0 pa-0 elevation="1">
        <v-list-item two-line @click="open(url)" @mousedown.middle="openInNewTab(url)">
            <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                    {{ title }}
                    <v-icon>mdi-link</v-icon>
                </v-list-item-title>
            </v-list-item-content>

            <slot name="logo"></slot>
        </v-list-item>
    </v-card>
</template>

<script>

export default {
    name: "DocumentationEntry",
    props: ['title', 'url'],
    methods: {
        open(url) {
            window.location.href = url;
        },
        openInNewTab(url) {
            window.open(url, '_blank').focus();
        },
    },
}
</script>

<style scoped>

</style>
